import Vue from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue from 'bootstrap-vue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/free-solid-svg-icons';

import App from './App.vue';
// import './registerServiceWorker'; PWA, but needs to be properly set up in production.
import router from './router/router';
import store from './vuex/store';

Vue.config.productionTip = false;

// Bootstrap Vue
Vue.use(BootstrapVue);

// Fontawesome
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
